export default __webpack_public_path__ + "static/shyamal-arora-5baa14ee018be2e2b3d705bc7c110e0b.png";